import React, { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { Field, Formik } from "formik";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import PhoneInput from "./PhoneInput";
import { UPDATE_PROFILE } from "../../GraphQL/settings/mutations";
import { IProfile } from "../../interfaces";

interface FormData {
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

const UserSettings = ({ profile }: IProfile) => {
  const [updateProfile, updateResponse] = useMutation(UPDATE_PROFILE);

  useEffect(() => {
    if (updateResponse.called && updateResponse.error) {
      alert("Something went wrong, please try again later");
      return;
    }
    if (updateResponse.called && !updateResponse.loading) {
      alert("User details updated successfully");
    }
  }, [updateResponse]);

  const getFormData = () => {
    return {
      firstName: profile.firstName || "",
      lastName: profile.lastName || "",
      phoneNumber: profile.phoneNumber || "",
    };
  };

  const doSubmit = (formData: FormData) => {
    updateProfile({
      variables: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phoneNumber: formData.phoneNumber,
      },
    });
  };

  return (
    <Formik initialValues={getFormData()} onSubmit={doSubmit}>
      {({
        handleSubmit,
        handleChange,
        values,
        errors,
        handleBlur,
        touched,
        setFieldValue,
      }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Card className="border-0">
              <CardContent className="p-0">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2 mb-3">
                    <Label htmlFor="formFirstName">First name*</Label>
                    <Input
                      id="formFirstName"
                      type="text"
                      name="firstName"
                      value={values.firstName}
                      onChange={handleChange}
                      placeholder="Enter first name"
                      required
                    />
                  </div>
                  <div className="space-y-2 mb-3">
                    <Label htmlFor="formLastName">Last name*</Label>
                    <Input
                      id="formLastName"
                      type="text"
                      name="lastName"
                      value={values.lastName}
                      onChange={handleChange}
                      placeholder="Enter last name"
                      required
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2 mb-3">
                    <Label htmlFor="formMobile">Mobile phone*</Label>
                    <Field
                      component={PhoneInput}
                      field={{
                        name: "phoneNumber",
                        value: values.phoneNumber,
                      }}
                      onChange={handleChange}
                      form={{
                        errors: errors,
                        handleBlur: handleBlur,
                        setFieldValue: setFieldValue,
                        touched: touched,
                      }}
                    />
                  </div>
                  <div></div>
                </div>
                <div className="flex justify-end pt-lg border-t border-slate-200 dark:border-slate-700">
                  <Button size="sm" type="submit" className="min-w-[120px]">
                    Save Changes
                  </Button>
                </div>
              </CardContent>
            </Card>
          </form>
        );
      }}
    </Formik>
  );
};

export default UserSettings;
